module.exports = __webpack_public_path__ + "static/img/S1X.1f8f7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/S1X.png
// module id = X4Ji
// module chunks = 1